const baseUrl = 'https://dev.sourtrack.com';

export const environment = {
  production: false,
  baseUrl: baseUrl,
  coreApiBaseUrl: baseUrl + '/core',
  documetApiBaseUrl: baseUrl + '/documents',
  identityApiBaseUrl: baseUrl + '/identity',
  communicationApiBaseUrl: baseUrl + '/communication',
  financeApiBaseUrl: baseUrl + '/finance',
  externalApiBaseUrl: baseUrl + '/external',
  clientId: 'sourtrack_web',
  scope: 'sourtrack_api',
  mojitoTrackingUrl: 'https://app.pre.mojito360.com/tracking/detail/',
  odooBaseUrl: 'https://empresascectestt36.odoo.com/odoo',
  documentRestrictionTypes: {
    gd: { aliases: ['GD', 'Guía de Despacho', 'Guia de Despacho', 'GD - Guía de Despacho', 'GD - Guia de Despacho'] },
    eir: { aliases: ['EIR', 'Equipment Interchange Receipt', 'EIR - Equipment Interchange Receipt'] },
    license: { aliases: ['Licencia'] },
    identityCard: { aliases: ['Cédula de identidad', 'Cedula de identidad'] },
    technicalReview: { aliases: ['Revisión técnica vehicular', 'Revisión técnica', 'Revision tecnica vehicular', 'Revision tecnica'] },
    emissionsCertificate: { aliases: ['Certificado de emisiones'] },
    circulationPermit: { aliases: ['Tarjeta de circulación/Permiso de circulación', 'Permiso de circulación', 'Tarjeta de circulacion/Permiso de circulacion', 'Permiso de circulacion'] },
    soap: { aliases: ['SOAP/SOAT', 'SOAP', 'SOAT'] },
    propertyCard: { aliases: ['Tarjeta de propiedad/Padrón', 'Padrón', 'Tarjeta de propiedad', 'Tarjeta de propiedad/Padron', 'Padron'] },
    deconsolidationReport: { aliases: ['Informe de desconsolidación', 'Informe de desconsolidacion'] },
  },
  // Tipos de documento que admite «Subir y analizar con IA» (SOU-570): solo el BL, que es lo único
  // que lee el motor. Por id y no por nombre: el nombre cambia entre entornos y el 61 es BL en PRE
  // pero «Póliza de Responsabilidad Civil» en producción. El 3 es el BL en dev, PRE y producción.
  aiUploadDocumentTypeIds: [3],
};
